module.exports = __webpack_public_path__ + "img/21C.69d26ee7.png";